export default function useDisplayPhone (phoneNumber: string | null) {
  if (!phoneNumber) { return ""; }
  const hasDialCode = phoneNumber.startsWith("+");
  const phone = phoneNumber.replaceAll(" ", "");
  const dialCode = hasDialCode ? phone.slice(0, 4) : "";
  const first = hasDialCode ? phone.slice(4, 7) : phone.slice(0, 3);
  const last = phone.slice(-2);
  const len = phone.length - (hasDialCode ? 9 : 5);
  const hiddenPhone = `${first}${"*".repeat(len)}${last}`.match(/.{1,3}/g)!.join(" ");
  return `${dialCode} ${hiddenPhone}`.trim();
}
